// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TreemapIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TreemapIcon" ref={forwardedRef} {...props}>
      <path d="M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.5 11.5h3.25v-11H4.5zm8.75 0h2.25v-5h-2.25zm-1.5 0v-5h-2.5v5zM9.25 9h6.25V4.5H9.25z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TreemapIcon = /* @__PURE__ */ Object.assign(TreemapIconComponent, {
  displayName: 'TreemapIcon',
});
